/* eslint react-hooks/exhaustive-deps: "warn" */

import cn from 'classnames';

import { Section } from 'ui/molecules/Section/Section';

import styles from './CoverageSection.module.scss';

import type { CoverageDot, CoverageSectionProps } from './CoverageSection.types';

const DOT_CLASS: Record<CoverageDot, string> = {
  green: styles.dotGreen,
  amber: styles.dotAmber,
  red: styles.dotRed,
  neutral: styles.dotNeutral,
};

const rowWeight = (value?: string) => {
  const parsed = value ? parseInt(value, 10) : NaN;

  return Number.isNaN(parsed) ? 0 : parsed;
};

export const CoverageSection = ({ title, description, actions, rows, className }: CoverageSectionProps) => {
  const maxWeight = Math.max(...rows.map((row) => rowWeight(row.value)), 1);

  return (
    <Section
      theme="dark"
      layout="split"
      splitAlign="center"
      className={className}
      title={title}
      description={description}
      actions={actions}
    >
      <div className={styles.grid}>
        {rows.map((row) => (
          <div key={row.label} className={styles.card}>
            {row.dot ? (
              <>
                <div className={styles.cardHead}>
                  <span className={cn(styles.dot, DOT_CLASS[row.dot])} />
                  <span className={styles.region}>{row.label}</span>
                </div>

                {row.description && <p className={styles.outcomeText}>{row.description}</p>}
              </>
            ) : (
              <>
                <div className={styles.cardHead}>
                  <span className={styles.region}>{row.label}</span>
                  {row.value && <span className={styles.count}>{row.value}</span>}
                </div>

                <div className={styles.bar}>
                  <div className={styles.barFill} style={{ width: `${(rowWeight(row.value) / maxWeight) * 100}%` }} />
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </Section>
  );
};
